import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../firebase';

/** Dedupe rapid remounts / Strict Mode double-mount per listing per session. */
const DEDUPE_MS = 2500;
const storageKey = (listingId) => `pxc_lv_${listingId}`;

/**
 * Record a listing detail page view for admin activation analytics.
 * Fire-and-forget; failures are silent.
 *
 * @param {string} listingId
 * @param {string | null | undefined} ownerId
 */
export function recordListingView(listingId, ownerId) {
  if (!listingId || typeof listingId !== 'string') return;

  const uid = auth.currentUser?.uid ?? null;
  // Owner browsing their own listing is not buyer engagement.
  if (uid && ownerId && uid === ownerId) return;

  const now = Date.now();
  try {
    const prev = Number(sessionStorage.getItem(storageKey(listingId)) || '0');
    if (now - prev < DEDUPE_MS) return;
    sessionStorage.setItem(storageKey(listingId), String(now));
  } catch (_) {
    /* private mode — still log the view */
  }

  addDoc(collection(db, 'listingViewEvents'), {
    listingId,
    ownerId: ownerId || null,
    uid,
    createdAt: serverTimestamp(),
  }).catch(() => {
    /* non-blocking */
  });
}

/** Admin dashboards reference when listing view tracking began. */
export const LISTING_VIEW_TRACKING_START = new Date('2026-08-17T00:00:00Z');
